import * as React from 'react';
import { IconProps } from '../types';

const IcMenuControlPanel2 = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M7.349 10.422a1.79 1.79 0 0 1 1.504.51l.995.995.94-.937L9.43 9.635a.543.543 0 0 1 .767-.767l1.36 1.36.94-.937-.998-.999a1.795 1.795 0 0 1-.51-1.504 4.233 4.233 0 0 0-4.82-4.742.252.252 0 0 0-.141.427l1.28 1.28c.61.61.61 1.596 0 2.202l-.787.787c-.61.61-1.596.61-2.2 0l-1.286-1.28a.253.253 0 0 0-.426.14 4.233 4.233 0 0 0 4.741 4.82ZM15.315 12.11l-.941.936 5.587 5.587a.543.543 0 0 1-.767.766l-5.587-5.587-.94.937 5.756 5.757a1.87 1.87 0 0 0 2.644-2.644l-5.752-5.753Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M17.474 8.38h2.482l2.483-4.962-1.24-1.239-4.964 2.478V7.14l-6.748 6.726-1.214-1.21-4.89 4.89a2.606 2.606 0 0 0 0 3.69 2.607 2.607 0 0 0 3.688 0l4.89-4.891-1.239-1.24 6.752-6.726Z"
    />
  </svg>
);

export default IcMenuControlPanel2;
